import React, { Fragment, useState } from 'react';
import { Button, List, ListItem, ListItemText } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import Popover from '@material-ui/core/Popover';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Link, useRouteMatch } from 'react-router-dom';
import * as ROUTES from '../../routes/';


const useStyles = makeStyles({
    column3: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexBasis: '28%',
        position: 'relative',
        margin: '0 0 0 10px',
    },
    button1: {
        fontWeight: 900,
        fontSize: 15,
        color: 'white',
        textTransform: 'initial',
        paddingLeft: 0,
    },
    button2: {
        fontWeight: 900,
        fontSize: 15,
        color: 'white',
        whiteSpace: 'nowrap',
        textTransform: 'initial',
        padding: '6px 16px 6px 8px',
    },
    button3: {
        fontWeight: 900,
        fontSize: 15,
        color: '#013957',
        backgroundColor: 'white',
        whiteSpace: 'nowrap',
        textTransform: 'initial',
        borderRadius: 22,
        padding: '7px 12px',
        '&:focus': {
            backgroundColor: 'white',
        },
        '&:hover': {
            backgroundColor: '#35b9b6',
            color: 'white',
        },
    },
    littleList: {
        border: '4px solid #f5f5f5',
    },
    listItem: {
        color: '#484848',
    },
    listItemdisable: {
        color: '#969696',
        cursor: 'not-allowed',
    },
    link: {
        textDecoration: 'none',
    },
    buttonSign: {
    width: 144,
    height: 40,
    color: '#013957',
    borderRadius: '30px',
    border: 'white',
    padding: '7px 12px',
    fontSize: 15,
    fontWeight: 900,
    whiteSpace: 'nowrap',
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#35b9b6',
      color: 'white !important'
    }
  },
    // itemText5: {
    //     color: '#969696',
    //     '& span': {
    //         fontSize: 14,
    //     },
    //     '&:hover': {
    //         color: '#484848',
    //     },
    // },
    // '@media screen and (max-width: 1359.98px)': {
    //     littleList: {
    //         display: 'none',
    //     },
    // },
})

function AuthSection(props) {
   
    const landingLawyers = useRouteMatch(ROUTES.LANDING_PAGE);
    const handleClickRegister = () => {
        setOpen(prevOpen => !prevOpen);
        //setOpenRegister(!openRegister);
    };
    const handleClickSignIn = () => {
        setOpenSignIn(prevOpenSignIn => !prevOpenSignIn);
        //setOpenRegister(!openRegister);
    };
    const classes = useStyles()
    const [open, setOpen] = React.useState(false);
    const [openSignIn, setOpenSignIn] = React.useState(false);

    const anchorRef = React.useRef(null);
    const anchorRefSN = React.useRef(null);


    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const handleCloseSN = event => {
        if (anchorRefSN.current && anchorRefSN.current.contains(event.target)) {
            return;
        }

        setOpenSignIn(false);
    };


    const prevOpen = React.useRef(open);
    const prevOpenSignIn = React.useRef(openSignIn);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        if (prevOpenSignIn.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
        prevOpenSignIn.current = open;

    }, [open, openSignIn]);

    return (
        <Fragment>

            <Button ref={anchorRef} classes={{ root: classes.button1 }} onClick={handleClickRegister}>Regístrate {open ? <ExpandLess /> : <ExpandMore />}</Button>
            <Button ref={anchorRefSN} classes={{ root: classes.button1 }} onClick={handleClickSignIn}>Inicia sesión {openSignIn ? <ExpandLess /> : <ExpandMore />}</Button>

{/*             <Link to={landingLawyers? ROUTES.SIGNIN : ROUTES.SIGN_IN_MAIN_CLIENT}><Button classes={{ root: classes.button2 }}>Inicia sesión</Button></Link>
 */}        <Link to={ROUTES.LANDING_PAGE_300} className={classes.buttonSign} style={{color: '#013957'} }>¿Eres Abogado?</Link>

            <Popover open={open} anchorEl={anchorRef.current} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}>

                <ClickAwayListener onClickAway={handleClose}>
                    <List component="div" disablePadding classes={{ root: classes.littleList }}>
                       {/*  <Link to={ROUTES.SIGNUP_LAWYER} className={classes.link}>
                            <ListItem button classes={{root: classes.listItemdisable}}>
                                <ListItemText primary="Registrarme como abogado" classes={{ root: classes.itemText5 }} />
                           </ListItem> 
                        </Link> */}
                       {/*  <Link to={ROUTES.SIGNUP_LAWFIRM} className={classes.link}> 
                            <ListItem button classes={{root: classes.listItemdisable}}>
                                <ListItemText primary="Registrarme como despacho" classes={{ root: classes.itemText5 }} />
                            </ListItem>
                        </Link> */}
                        <Link to={ROUTES.SIGN_UP_CLIENT} className={classes.link}>
                            <ListItem button classes={{root: classes.listItem}}>
                                <ListItemText primary="Registrarme como usuario" classes={{ root: classes.itemText5 }} />
                            </ListItem>
                        </Link>
                    </List>
                </ClickAwayListener>
            </Popover>


            <Popover open={openSignIn} anchorEl={anchorRefSN.current} anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}>

                <ClickAwayListener onClickAway={handleCloseSN}>
                    <List component="div" disablePadding classes={{ root: classes.littleList }}>
                        <Link to={ROUTES.SIGN_IN_MAIN_CLIENT} className={classes.link}>
                            <ListItem button classes={{root: classes.listItem}}>
                                <ListItemText primary="Inicia sesión usuario" classes={{ root: classes.itemText5 }} />
                            </ListItem>
                        </Link>
                        <Link to={ROUTES.SIGNIN} className={classes.link}>
                            <ListItem button classes={{root: classes.listItem}}>
                                <ListItemText primary="Inicia sesión abogado" classes={{ root: classes.itemText5 }} />
                            </ListItem>
                        </Link>
                    </List>
                </ClickAwayListener>
            </Popover>



        </Fragment>
    );
}

export default AuthSection;